export const scrollSize = {
  width: '10px',
  height: '14px'
};
